webpackJsonp([17],{

/***/ "./abound-open.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__("../../node_modules/ramda/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ramda__);


var addClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_ramda__["curry"])(function (className, el) {
    return el.classList.add(className);
});
var removeClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_ramda__["curry"])(function (className, el) {
    return el.classList.remove(className);
});
var hasClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_ramda__["curry"])(function (className, el) {
    return el.classList.contains(className);
});
var toggleClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_ramda__["curry"])(function (className, el) {
    return hasClass(className, el) ? removeClass(className, el) : addClass(className, el);
});

window.aboundOpener = function (buttonEls, closedClass, animationTransitionTimeMs) {
    if (!buttonEls || !buttonEls.length) return;

    var getParentSection = function getParentSection(el) {
        return document.getElementById(el.dataset.parentSection);
    };

    buttonEls.forEach(function (el) {
        return el.addEventListener('click', function (_ref) {
            var currentTarget = _ref.currentTarget;
            return toggleClass(closedClass, getParentSection(currentTarget));
        });
    });
};

/***/ })

},["./abound-open.js"]);


// WEBPACK FOOTER //
// scripts/abound-open.d075e11b60a6b8e95314.js